import React, { useState } from 'react';

function HeadlineForm() {
  // useState hook to store the headline text
  const [headlineText, setHeadlineText] = useState('');

  // Handle input changes
  const handleInputChange = (event) => {
    setHeadlineText(event.target.value);
  };

  // Handle form submission
  const handleSubmit = () => {
    alert("Submitted: " + headlineText);
  };

  return (
    <>
      <input 
        type="text" 
        id="headline"
        value={headlineText}
        onChange={handleInputChange}
      />
      <button className="btn submit-btn" onClick={handleSubmit}>
        Submit
      </button>
    </>
  );
}

export default HeadlineForm;

